(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["4-step-routine"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initSlider(root) {
      var track = root.querySelector('[id^="fsr-track-"]');
      var dotsWrap = root.querySelector('[id^="fsr-dots-"]');
      if (!track) return;
      var dots = dotsWrap ? dotsWrap.querySelectorAll('.fsr-dot') : [];

      function updateDots() {
        if (!dots.length) return;
        var cards = track.querySelectorAll('.fsr-card-wrap');
        if (!cards.length) return;
        var trackRect = track.getBoundingClientRect();
        var center = trackRect.left + trackRect.width / 2;
        var closestIdx = 0;
        var closestDist = Infinity;
        cards.forEach(function(card, i) {
          var r = card.getBoundingClientRect();
          var cardCenter = r.left + r.width / 2;
          var dist = Math.abs(cardCenter - center);
          if (dist < closestDist) {
            closestDist = dist;
            closestIdx = i;
          }
        });
        dots.forEach(function(d, i) {
          d.classList.toggle('is-active', i === closestIdx);
        });
      }

      var scrollTimer;
      track.addEventListener('scroll', function() {
        if (scrollTimer) cancelAnimationFrame(scrollTimer);
        scrollTimer = requestAnimationFrame(updateDots);
      }, { passive: true });

      dots.forEach(function(dot, idx) {
        dot.addEventListener('click', function() {
          var cards = track.querySelectorAll('.fsr-card-wrap');
          if (cards[idx]) {
            var card = cards[idx];
            var trackRect = track.getBoundingClientRect();
            var cardRect = card.getBoundingClientRect();
            var offset = (cardRect.left + cardRect.width / 2) - (trackRect.left + trackRect.width / 2);
            track.scrollBy({ left: offset, behavior: 'smooth' });
          }
        });
      });

      updateDots();
    }

    function initAll() {
      document.querySelectorAll('.four-step-routine').forEach(initSlider);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function(e) {
      var sec = e.target.querySelector('.four-step-routine') || (e.target.classList && e.target.classList.contains('four-step-routine') ? e.target : null);
      if (sec) initSlider(sec);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
